import React from 'react';
import { Modal } from 'react-bootstrap';
import Skeleton from 'wsm-skeleton';

import { SPIN_360_LABEL } from '../../global-constants';

/**
 * Loading state for the lazily loaded PanoramicModal chunk.
 *
 * Rendered only while that chunk is still in flight AND the shopper has already
 * clicked the 360 button, so a slow connection gets feedback instead of a
 * button that appears to do nothing. While the modal is closed the Suspense
 * fallback stays null, otherwise this would flash on every VDP that merely has
 * a panoramic image, since PanoramicModal mounts on detection rather than on
 * click.
 *
 * Deliberately plain: PanoramicModal.scss ships inside the lazy chunk, so the
 * panoramic-modal styles are not available yet at this point. react-bootstrap
 * and wsm-skeleton are already in the main bundle, so this adds no meaningful
 * weight to pages that never open the spin.
 */
const PanoramicModalFallback = () => (
	<Modal
		show
		id="ws-vehicle-gallery-panoramic-modal-loading"
		className="responsive"
		dialogClassName="my-0 mx-auto center-block-vertical"
		backdrop="static"
		aria-modal="true"
		aria-label={SPIN_360_LABEL}
	>
		<Modal.Body>
			<Skeleton
				skeletonClasses="w-100"
				aspectRatio="16by9"
				dataTestId="panoramic-modal-skeleton"
			/>
		</Modal.Body>
	</Modal>
);

export default PanoramicModalFallback;
